module.exports = __webpack_public_path__ + "img/fons2.825a1484.jpg";